
export type CreateTweetWithMedia202 = {
  /** ID of the created tweet */
  tweetId: string;
};
